<template>
  <div class="side-center-integrations">
    <div class="integrations-title">
      <span>{{ $i18nPresenter.t("Integrations") }}</span>
      <aha-antd-button
        v-aha-emit-action
        variant="tertiary"
        size="sm"
        name="integrationCenter"
        @click="navigateToIntegrations"
      >
        <aha-icon
          name="CaretRight"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        />
      </aha-antd-button>
    </div>
    <div class="integrations-content">
      <div class="integrations-list">
        <div class="integrations-item">
          <a
            href="https://workspace.google.com/marketplace/app/ahaslides_quiz_live_polls_word_clouds_mo/362095682738"
            target="_blank"
            rel="noopener noreferrer"
            v-aha-tooltip="{arrow: true, content: 'Google Slides'}"
            v-aha-emit-action
            name="googleSlidesIntegration"
            class="integration-link"
          >
            <aha-icon
              class="integration-icon"
              name="googleslide"
              width="28"
              height="28"
              maintainColor
            />
          </a>
        </div>
        <div class="integrations-item">
          <a
            href="https://appsource.microsoft.com/en-us/product/office/WA200004824?tab=Overview"
            target="_blank"
            rel="noopener noreferrer"
            v-aha-tooltip="{arrow: true, content: 'PowerPoint'}"
            v-aha-emit-action
            name="powerPointIntegration"
            class="integration-link"
          >
            <aha-icon
              class="integration-icon"
              name="PowerPoint"
              width="28"
              height="28"
              maintainColor
            />
          </a>
        </div>
        <div class="integrations-item">
          <a
            href="https://marketplace.zoom.us/apps/dkSZ5rgQTrmPRKS0GJcjNg"
            target="_blank"
            rel="noopener noreferrer"
            v-aha-tooltip="{arrow: true, content: 'Zoom'}"
            v-aha-emit-action
            name="zoomIntegration"
            class="integration-link"
          >
            <aha-icon
              class="integration-icon"
              name="zoom"
              width="28"
              height="28"
              maintainColor
            />
          </a>
        </div>
        <div class="integrations-item">
          <a
            href="https://appsource.microsoft.com/en-us/product/office/WA200005531?tab=Overview"
            target="_blank"
            rel="noopener noreferrer"
            v-aha-tooltip="{arrow: true, content: 'Microsoft Teams'}"
            v-aha-emit-action
            name="msTeamsIntegration"
            class="integration-link"
          >
            <aha-icon
              class="integration-icon"
              name="Teams"
              width="28"
              height="28"
              maintainColor
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideCenterIntegrations',
  props: {
    presentation: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    navigateToIntegrations() {
      const url = this.$router.resolve('/apps/integrations').href
      window.open(url, '_blank')
    },
    openInNewTab(path) {
      const url = this.$router.resolve(path).href
      window.open(url, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.side-center-integrations {
  .integrations-title {
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 14px 22px;
    color: #191F2D;

    span {
      text-transform: lowercase;
      &::first-letter {
        text-transform: uppercase;
      }
    }

    button {
      cursor: pointer;
    }
  }

  .integrations-content {
    padding: 0 16px;
  }

  .integrations-list {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .integrations-item {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    background-color: transparent;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #e0e3ed;
    }
  }

  .integration-link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}

// Mobile specific styles
@media (max-width: 767.98px) {
  .side-center-integrations {
    .integrations-list {
      gap: 8px;
    }
  }
}
</style>
